
export default function Footer() {
  return (
    <footer className="bg-[#5a7c3e] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/d32fda172531ebc64455c87992c4a988/37f3c9c5787f015286f5278564313857.jpeg"
                alt="Green Choice Bag"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">Green Choice Bag</span>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Your trusted <strong>wholesale supplier</strong> of <strong>eco-friendly paper bags</strong>. Quality products, competitive pricing, and exceptional service.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#products" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Products
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Benefits
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill text-base mt-0.5"></i>
                <a href="tel:626-346-8383" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  626-346-8383
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-fill text-base mt-0.5"></i>
                <a href="mailto:hello@greenchoicebag.com" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  hello@greenchoicebag.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-fill text-base mt-0.5"></i>
                <span className="text-white/80">City of Industry, CA</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Business Hours</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>Monday - Friday: 8am - 6pm</li>
              <li>Saturday: 9am - 4pm</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-sm text-white/70">
              &copy; 2025 Green Choice Bag. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
